<template>
  <span>
    <slot></slot>
  </span>
</template>

<script>
export default {
  data () {
    return {
      mounted: false
    }
  },
  mounted () {
    this.mounted = true
    this.init()
  },
  methods: {
    async init () {
      if(this.mounted) {
        this.$k.linkifyText(this.$el)
      }
    }
  }
}
</script>

<style>

</style>